export default __webpack_public_path__ + "static/media/projectMode-thumbnail.36f24749.png";